/*jshint esversion: 6 */

class PageChatToggle {

  constructor($main) {
    if (!this.initDomElements($main)) return false;

    this.domElements.closeBtn.on('click', () => {
      this.close();
    });
  }

  close() {
    this.domElements.main.removeClass('page-chat-toggle--open');
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;

    this.domElements.closeBtn = this.domElements.main.find('.page-chat-toggle__close-btn');
    return true;
  }

}

export default PageChatToggle;
